export const TEXTS = {
  MODAL_ADD_TITLE: 'Добавление тегов',
  MODAL_CHANGE_TITLE: 'Изменение тегов',
  MODAL_TEXT:
    'Отмечайте тегом музыкальную зону, ответственного или город, чтобы быстро фильтровать адреса или рекламные кампании.',
  MODAL_AUTOCOMPLETE_LABEL: 'Тег',
  MODAL_CONFIRM_BUTTON: 'Сохранить',
};
